module.exports = __webpack_public_path__ + "img/about-us.deeccb5a.jpg";